import { useState, useEffect } from 'react'
import { compareVersions } from 'compare-versions';
import { gql, useSubscription } from '@apollo/client';


const LAST_VERSION_QUERY = gql`
subscription {
    version {
        version
    }
}
`

export const useWarnVersion = () => {

    const [lookupData, setlookupData] = useState({})
    const data = useSubscription(LAST_VERSION_QUERY)

    useEffect(() => {
        if (!data.loading && data.data && data.data.version && data.data.version.length > 0) {
            setlookupData({
                "warnVersion": compareVersions((process.env.REACT_APP_VERSION).toString(), data.data.version[0].version, '<'),
                "versionNumber": data.data.version[0].version
            })
        }
    }, [data.loading, data.data])

    return lookupData
}
